import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from './actions/actionCreators';

import Main from './Main';

function mapStateToProps(state) {
  return {
    form: state.form,
    weather: state.weather,
    transit: state.transit,
    stop: state.stop,
    minibus: state.minibus
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

const App = connect(mapStateToProps, mapDispatchToProps)(Main);

export default App;


// WEBPACK FOOTER //
// ./src/App.js